import React from "react";
import styles from "./RiskAssessmentMatrixShared.module.css";
import RiskAssessmentMatrixTable from "./RiskAssessmentMatrixTable";

export default function DefaultRiskMatrixSection({ swmsData }) {
  const consequences = swmsData && swmsData.meta && Array.isArray(swmsData.meta.consequences)
    ? [...swmsData.meta.consequences].sort((a, b) => Number(a.consequence_order) - Number(b.consequence_order))
    : [];

  const ascConsequences = [...consequences].sort((a, b) => Number(a.value) - Number(b.value));

  const likelihoods = swmsData && swmsData.meta && Array.isArray(swmsData.meta.likelihoods)
    ? [...swmsData.meta.likelihoods].sort((a, b) => Number(a.likelihood_order) - Number(b.likelihood_order))
    : [];
  
  const ascLikelihoods = [...likelihoods].sort((a, b) => Number(a.value) - Number(b.value));

  const risks = swmsData && swmsData.meta && swmsData.meta.risk_ratings && Array.isArray(swmsData.meta.risk_ratings.risk_rating_items)
    ? [...swmsData.meta.risk_ratings.risk_rating_items].sort((a, b) => Number(a.rating_order) - Number(b.rating_order))
    : [];

  const hierarchyControls = swmsData && swmsData.meta && Array.isArray(swmsData.meta.hierarchy_of_controls)
    ? swmsData.meta.hierarchy_of_controls
    : [];

  const hierarchyData = hierarchyControls.map((item, index) => ({
    id: item.id || index + 1,
    name: item.name || `Control ${index + 1}`,
    description: item.description || ""
  }));

  return (
    <div className="container-fluid my-3">
      <div className={styles.stepsRow}>
        <div className={styles.step}>
          <div className={styles.stepHeading}>
            <span className={styles.stepNum}>1</span>
            Likelihood
          </div>
          <div className={styles.tableShell}>
            <table className={styles.likelihoodTable}>
              <thead>
                <tr>
                  <th className={styles.likelihoodHeadCell}>Likelihood</th>
                  <th className={`${styles.likelihoodHeadCell} ${styles.valueCol}`}>Value</th>
                  <th className={styles.likelihoodHeadCell}>Description</th>
                </tr>
              </thead>
              <tbody>
                {ascLikelihoods.map((likelihood) => (
                  <tr key={likelihood.id || likelihood.value}>
                    <td className={styles.likelihoodBodyLabel}>{likelihood.name || ""}</td>
                    <td className={`${styles.likelihoodBodyValue} ${styles.valueCol}`}>{likelihood.value}</td>
                    <td className={styles.likelihoodBodyDescription}>{likelihood.description || ""}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className={styles.step}>
          <div className={styles.stepHeading}>
            <span className={styles.stepNum}>2</span>
            Consequence
          </div>
          <div className={styles.tableShell}>
            <table className={styles.likelihoodTable}>
              <thead>
                <tr>
                  <th className={styles.likelihoodHeadCell}>Consequence</th>
                  <th className={`${styles.likelihoodHeadCell} ${styles.valueCol}`}>Value</th>
                  <th className={styles.likelihoodHeadCell}>Description</th>
                </tr>
              </thead>
              <tbody>
                {ascConsequences.map((consequence) => (
                  <tr key={consequence.id || consequence.value}>
                    <td className={styles.likelihoodBodyLabel}>{consequence.name || ""}</td>
                    <td className={`${styles.likelihoodBodyValue} ${styles.valueCol}`}>{consequence.value}</td>
                    <td className={styles.likelihoodBodyDescription}>{consequence.description || ""}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>



      <div className="row mt-2">
        <div className="col-12">
          <div className={styles.stepHeading}>
            <span className={styles.stepNum}>3</span>
            Risk Matrix &middot; Likelihood &times; Consequence
          </div>
          <RiskAssessmentMatrixTable 
            likelihoods={likelihoods} 
            consequences={consequences} 
            risks={risks} 
          />
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-12">
          <div className={styles.ramBlockHd}>
            Risk Rating Guide
          </div>
          <div className={styles.ramRatingGuideContainer}>
            {risks.map((risk) => (
              <div
                key={risk.id}
                className={styles.ramRatingCard}
                style={{ backgroundColor: risk.risk_colours }}
              >
                <div className={styles.ramRatingCardLabel}>
                  <span>{risk.risk_ratings}</span>
                  <span className={styles.ramRatingCardRange}>
                    {risk.risk_rating_low_value} - {risk.risk_rating_high_value}
                  </span>
                </div>
                <div className={styles.ramRatingCardNote}>
                  {risk.risk_rating_description || ""}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-12">
          <div className={styles.ramBlockHd}>
            Hierarchy of Control
          </div>
          {hierarchyData.length === 0 ? null : (
            <div className={styles.ramHierarchyContainer}>
              {hierarchyData.map((control, index) => (
                <div key={control.id || index} className={styles.ramHierarchyCard}>
                  <div className={styles.ramHierarchyCardNumber}>
                    {index + 1} — {control.name}
                  </div>
                  <div className={styles.ramHierarchyCardDescription}>
                    {control.description || ""}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
